import { render } from "./ViewTransactionPage.vue?vue&type=template&id=f6e7d816&ts=true"
import script from "./ViewTransactionPage.vue?vue&type=script&lang=ts"
export * from "./ViewTransactionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__